module.exports = __webpack_public_path__ + "static/media/lightning-weather_200_transparent.b6e277ee.gif";